<template>
    <div class="container">
        <div class="row">
            <div v-show="isLogged" class="col-md-12">
                <br>
                <p class="text-center">
                    {{ text.pageDoesntExist }}
                </p>
                <br>
            </div>
            <div v-show="!isLogged" class="col-md-12">
                <br>
                <p class="text-center">
                    {{ text.sessionExpired }}
                </p>
                <br>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div v-show="isLogged" class="col-md-2">
                <a href="/" class="btn btn-sm btn-outline-secondary" role="button" aria-pressed="true">
                    {{ text.backToHomePage }}
                </a>
            </div>
            <div v-show="!isLogged" class="col-md-2">
                <a :href="connectUrl" class="btn btn-sm btn-outline-secondary" role="button" aria-pressed="true">
                    {{ text.login }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import resources from '../helpers/resources'
import Branding from '../helpers/branding'

export default {
    data() { return { text : resources } },
    computed: {
        isLogged() { return localStorage.getItem('user-token') != null },
        connectUrl() { return Branding.connectionUrl() }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Redirect.vue